import { Link } from "react-router-dom";

const stripImages = [
  "https://readdy.ai/api/search-image?query=Stylish%20leather%20sneakers%20displayed%20on%20a%20warm%20cork%20surface%20with%20dappled%20sunlight%20filtering%20through%20leaves%2C%20minimal%20lifestyle%20product%20photography%20with%20natural%20organic%20feel%2C%20soft%20earthy%20brown%20and%20cream%20tones%2C%20editorial%20quality%20with%20shallow%20depth%20of%20field&width=400&height=300&seq=strip-v3-1&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Elegant%20silk%20scarf%20draped%20gracefully%20over%20a%20smooth%20stone%20surface%20with%20soft%20pastel%20floral%20pattern%2C%20diffused%20morning%20light%20creating%20gentle%20highlights%2C%20minimal%20luxury%20accessory%20photography%20with%20delicate%20feminine%20aesthetic%2C%20blush%20and%20ivory%20color%20palette&width=400&height=300&seq=strip-v3-2&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Premium%20leather%20handbag%20with%20gold%20hardware%20placed%20on%20a%20light%20marble%20surface%2C%20natural%20side%20lighting%20from%20a%20nearby%20window%2C%20elegant%20minimalist%20fashion%20product%20photography%20with%20sophisticated%20neutral%20tones%2C%20clean%20composition%20emphasizing%20craftsmanship%20details&width=400&height=300&seq=strip-v3-3&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Stylish%20aviator%20sunglasses%20resting%20on%20a%20textured%20linen%20fabric%20in%20warm%20sand%20color%2C%20golden%20hour%20backlighting%20creating%20lens%20reflections%2C%20editorial%20fashion%20accessory%20photography%20with%20summery%20vibrant%20feel%2C%20warm%20amber%20and%20honey%20tones&width=400&height=300&seq=strip-v3-4&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Classic%20analog%20wristwatch%20with%20brown%20leather%20strap%20positioned%20on%20a%20dark%20wooden%20table%2C%20warm%20candlelight%20ambiance%20with%20soft%20glowing%20highlights%20on%20the%20watch%20face%2C%20intimate%20luxury%20product%20photography%20with%20rich%20mahogany%20and%20gold%20color%20palette&width=400&height=300&seq=strip-v3-5&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Artisanal%20ceramic%20vase%20with%20dried%20pampas%20grass%20arrangement%20on%20a%20minimal%20wooden%20shelf%2C%20soft%20diffused%20daylight%20from%20an%20adjacent%20window%2C%20Scandinavian%20interior%20styling%20photography%20with%20neutral%20cream%20and%20beige%20tones%2C%20clean%20minimalist%20home%20decor%20aesthetic&width=400&height=300&seq=strip-v3-6&orientation=landscape",
];

export default function CTASection() {
  const formSubmitAddr = "https://readdy.ai/api/form/d8tt8ckal24muhn2rb5g";

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
              Ready to Optimize Your Data?
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-8">
              Start exploring the <strong>acbuyspreadsheet</strong> system with our comprehensive guides, comparisons, and automation frameworks. Join thousands of data-driven professionals already using acbuyspreadsheet.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-500 text-primary-500 text-sm md:text-base font-semibold rounded-full hover:bg-primary-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                ACBuy Spreadsheet
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div className="max-w-md mx-auto bg-background-100/70 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2 text-center">
              Stay Updated
            </h3>
            <p className="text-sm text-foreground-500 text-center mb-5">
              Get the latest acbuyspreadsheet guides, tips, and updates delivered to your inbox.
            </p>

            <form
              data-readdy-form
              action={formSubmitAddr}
              method="POST"
              className="flex flex-col sm:flex-row gap-3"
            >
              <div className="contact-alt-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                required
                className="flex-1 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </div>

          {/* Bottom product image strip */}
          <div className="mt-14 md:mt-16 flex gap-3 md:gap-4 overflow-hidden">
            {stripImages.map((imgUrl, n) => (
              <div key={n} className="flex-shrink-0 w-40 md:w-48 aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src={imgUrl}
                  alt={`ACBuySpreadsheet featured product ${n + 1}`}
                  title={`ACBuySpreadsheet Product ${n + 1}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}